<div class="modal-header">
  <div class="modal-title"><img src="/assets/images/icons/icon-outline-eye.svg"> Previsualización de la campaña</div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>

</div>
<div class="modal-body" *ngIf="modelCampign">
  <div class="tit__campaña mb-3">
    <h4
      [ngClass]="{'email': modelCampign.IdCampaignMedia == LocalCampaignMedia.Email, 'sms': modelCampign.IdCampaignMedia == LocalCampaignMedia.Sms}"
      class="lateral__bar">Campaña: {{modelCampign.Title}}</h4>
    <button type="button" class="btn-pdf" (click)="generarPDF()">Descargar Campaña</button>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="output-inner-container"
        [ngClass]="{'email': modelCampign.IdCampaignMedia == LocalCampaignMedia.Email, 'sms': modelCampign.IdCampaignMedia == LocalCampaignMedia.Sms}"
        [innerHtml]="htmlOutput"></div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cerrar</button>
</div>